import { render, staticRenderFns } from "./Popularview.vue?vue&type=template&id=32cb81da&"
import script from "./Popularview.vue?vue&type=script&lang=js&"
export * from "./Popularview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports